import WebFont from 'webfontloader';

const URL_WHITNEY = 'https://asset.wsj.net/fonts.wsj.net/fonts/pkg/whitney-ssm.css';

/**
 * Preload fonts depending on product. If fonts are *not* preloaded, then
 * line breaks fail (because line breaks are determined with a fallback font).
 */
export function fonts(options, complete) {
  const { product, print } = options;
  const info = fontsInfo(product, print);
  let interval = 0;
  if (info === true) {
    complete();
  } else {
    const status = window.__charts_fonts_status__ =
      (typeof window.__charts_fonts_status__ === 'object') ?
      window.__charts_fonts_status__ : {};

    const callbackComplete = () => {
      status[info.product] = 'complete';
      complete();
    }

    const checkComplete = () => {
      if (status[info.product] === 'complete') {
        clearInterval(interval);
        complete();
      }
    }

    const checkQueued = () => {
      if (!areFontsLoading()) {
        clearInterval(interval);
        if (status[info.product] === 'complete') {
          complete();
        } else {
          status[info.product] = 'loading';
          WebFont.load({
            custom: info,
            active: callbackComplete,
            inactive: callbackComplete,
          });
        }
      }
    }

    if (status[info.product] === 'loading') {
      interval = setInterval(checkComplete, 1);
    } else if (status[info.product] === 'complete') {
      complete();
    } else {
      interval = setInterval(checkQueued, 1);
    }
  }
}

function areFontsLoading() {
  const status = window.__charts_fonts_status__;
  if (status) {
    const keys = Object.keys(status);
    for (let i = 0; i < keys.length; i++) {
      if (status[keys[i]] === 'loading') {
        return true;
      }
    }
  }
  return false;
}

function fontsInfo(product, print = false) {
  if (__ALL__ || __WSJ__) {
    if (product === 'wsj') {
      if (print) {
        return {
          product: 'wsj-print',
          families: [
            // 'Retina Standard Narrow:n3,n4,n6',
            // 'DJ5EscrowCond:n6'
            'DJ5RetinaNr Light',
            'DJ5RetinaNr Medium',
            'DJ5RetinaNr Semibold',
            'DJ5RetinaNr Bold',
            'DJ5RetinaAgReg Medium',
            'DJ5EscrowCond',
          ],
          urls: ['/assets/css/wsj-print.css']
        };
      } 
      else {
        return {
          product,
          families: ['Retina', 'Retina Narrow'],
          urls: ['https://www.wsj.com/fonts/retina.css']
        };
      }
    } 
  }
  if (__ALL__ || __BARRONS__) {
    if (product === 'barrons') {
      return {
        product,
        families: ['Theinhardt:n4,n6'],
        urls: ['https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
      };
    }
  }
  if (__ALL__ || __FINANCIALNEWS__) {
    if (product === 'financialnews') {
      return {
        product,
        families: ['Publico:n6','Theinhardt:n3,n4,n6'],
        urls: ['https://fonts.wsj.net/PublicoMedium.css', 'https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
      };
    }
  }
  if (__ALL__ || __MARKETWATCH__) {
    if (product === 'marketwatch') {
      return {
        product,
        families: ['Whitney SSm:n4,n5,n6'],
        urls: [URL_WHITNEY]
      };
    }
  }
  if (__ALL__ || __MANSIONGLOBAL__) {
    if (product === 'mansionglobal') {
      return {
        product,
        families: ['Chronicle Text G1 A:n6', 'Whitney SSm A:n4,n6,n7'],
        urls: ['https://www.mansionglobal.com/fonts/442807/457709E0582EC35B6.css']
      };
    }
  }
  if (__ALL__ || __HEATSTREET__) {
    if (product === 'heatstreet') {
      return {
        product,
        families: ['Ideal Sans B:n3,n6,n7', 'Ideal Sans B:n3,n6,n7'],
        urls: ['https://heatst.com/wp-content/themes/heatstreet/static/fonts/447427/CACC8AE198F1E0D08.css']
      };
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/chart/style/preload.js